require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-for-charlottesville.json") })
        }
      }, "path---blog-for-charlottesville");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-for-charlottesville!./.cache/json/blog-for-charlottesville.json
// module id = 804
// module chunks = 231608221292675